import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { CasesApi } from '../../../infrastructure/api/cases.api';
import { ApproveRequestCommand } from './approve-request.command';
import { ApproveRequestResult } from './approve-request.result';

@Injectable({ providedIn: 'root' })
export class ApproveRequestUseCase {
  private readonly _api = inject(CasesApi);
  private readonly _toast = inject(ToastProvider);

  public execute(command: ApproveRequestCommand): Observable<ApproveRequestResult> {
    return this._api.approveRequest(command.caseId, command.approvalRequestId).pipe(
      tap(() => {
        this._toast.success(
          'Approved',
          'The approval request has been approved.'
        );
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._toast.error(
          'Failed to approve',
          'Please try again or contact support if the issue persists.'
        );
        return throwError(() => error);
      })
    );
  }
}
